import React, { Component } from 'react'

// Styles
import './styles/questionAnswer.css'
import '../../../../src/styles/styles.css'

class QuestionAnswer extends Component {
  generateGradient (percentage = 0, startColor = '#dadada', endColor = 'white') {
    return {
      background: `linear-gradient(to right, ${startColor} ${percentage}%, ${endColor} ${percentage}%)`,
    }
  }

  renderPercentage () {
    if (this.props.statsForAnswer && this.props.showResults) {
      return (
        <p
          className="fontFamilyBold answerPercentage"
          style={this.props.showResults && this.props.isWinnerAnswer ? { color: '#fff' } : null}
        >
          {this.props.statsForAnswer.percent ? `${(Math.round(this.props.statsForAnswer.percent * 100) / 100)}%` : ''}
        </p>
      )
    }
    return null
  }

  render () {
    let { statsForAnswer } = this.props
    let style

    if (this.props.showResults) {
      if (this.props.isWinnerAnswer) {
        style = {
          borderWidth: 0,
          padding: 14,
          ...this.generateGradient(statsForAnswer.percent, '#50c9c0', '#42b7a9'),
        }
      } else {
        statsForAnswer = statsForAnswer || {}

        style = this.generateGradient(statsForAnswer.percent)
      }
    } else {
      style = this.generateGradient()
    }

    return (
      <div
        className={'textCenter questionAnswer'}
        style={style}
      >
        <div className="boxAnswer">
          <p
            className="fontFamilyBold questionAnswerText"
            style={this.props.showResults && this.props.isWinnerAnswer ? { color: '#fff' } : null}
          >
            {this.props.answer}
          </p>
        </div>

        {this.renderPercentage()}
      </div>
    )
  }
}

export default (QuestionAnswer)



// WEBPACK FOOTER //
// ./src/components/questionsWindow/questionAnswer/view.js